export const LinkedInIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.26667 14H1.96V5.94H4.26667V14ZM3.11333 4.92C2.36667 4.92 1.76 4.3 1.76 3.54C1.76 3.17517 1.90494 2.82536 2.16299 2.56731C2.42104 2.30926 2.77085 2.16432 3.13567 2.16432C3.50049 2.16432 3.85031 2.30926 4.10836 2.56731C4.36641 2.82536 4.51134 3.17517 4.51134 3.54C4.51134 4.3 3.90467 4.92 3.11333 4.92ZM14.24 14H11.94V10.08C11.94 9.2 11.92 8.08 10.72 8.08C9.5 8.08 9.32 9.04 9.32 10.02V14H7.02V5.94H9.24V6.98H9.27333C9.58 6.38 10.36 5.74 11.5 5.74C13.84 5.74 14.2467 7.28 14.2467 9.28V14H14.24Z"
      fill="#AAB3D0"
    />
  </svg>
);
